<template>
  <nav>
    <ul
      class="nav nav-tabs"
      role="tablist"
      aria-label="Access Point Levels">
      <li
        :class="{'active': isAccessPointActive(tab.accessPoint), 'disabled': disableLinks && !isAccessPointActive(tab.accessPoint)}"
        v-for="tab of tabInfo"
        role="none"
        :key="tab.accessPoint">
        <router-link
          v-if="!disableLinks"
          role="tab"
          :aria-selected="isAccessPointActive(tab.accessPoint)"
          :to="{ name: 'AnchorPage', params: { uuid: tab.accessPointUuid }, query: { draft: $route.query.draft } }"
          @click.native="clickedTab(tab)">{{ tab.label }}</router-link>
        <a
          v-else
          @click.prevent
          aria-selected="true"
          v-tooltip="!isAccessPointActive(tab.accessPoint) && disableMessage ? disableMessage : null">{{ tab.label }}</a>
      </li>
    </ul>
  </nav>
</template>

<script>
import { AccessPointsUtil } from '@/components/goals/common/access_points'
import { tooltip } from 'uiv'

export default {
  name: 'AccessPointTabs',
  directives: { tooltip },
  props: {
    activeAccessPoint: {
      type: String,
      validator(val) {
        return AccessPointsUtil.orderedValues.indexOf(val) > -1
      },
      default: AccessPointsUtil.valuesMap.GRADE_LEVEL
    },
    accessPointUuids: {
      type: Object,
      required: true,
    },
    disableLinks: {
      type: Boolean,
      default: false
    },
    disableMessage: {
      type: String,
      default: 'Not available on this page'
    }
  },
  computed: {
    tabInfo() {
      return AccessPointsUtil.orderedValues.map(ap => ({
        accessPoint: ap,
        accessPointUuid: this.accessPointUuids[ap],
        label: AccessPointsUtil.labelsMap[ap] + ' Goal'
      }))
    }
  },
  methods: {
    isAccessPointActive(accessPoint) {
      return accessPoint === this.activeAccessPoint
    },
    clickedTab({ accessPoint, accessPointUuid }) {
      this.$sendEvent('Clicked Access Point Tab', {
        access_point_level_clicked: accessPoint,
        access_point_uuid_clicked: accessPointUuid
      })
    }
  }
}
</script>

<style lang="less" scoped>
@accentColor: #1c5498;

.nav-tabs {
  padding-top: 4px;
  border-bottom: solid @accentColor 8px;

  li {
    width: 33.33%;
    text-align: center;
    margin-bottom: 0;

    & > a {
      font-weight: 500;
      font-size: 20px;
      color: @accentColor;
      margin-right: 0;
      border-left: 0;
      padding: 12px 0;
    }
  }

  li.active a,
  li.active a:focus,
  li.active a:hover {
    background: @accentColor;
    color: white;
    border: 1px solid @accentColor;
  }

  li.disabled a,
  li.disabled a:focus,
  li.disabled a:hover {
    background: #efefef;
    color: #999999;
    border-color: white;
    font-style: italic;
    font-weight: normal;
  }
}
</style>]
